const WORD_START_REG = /(^|[^\p{L}\p{N}'’])(\p{L})/gu;

export function titleCase(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(
      WORD_START_REG,
      (match, prefix, letter) => prefix + letter.toUpperCase()
    );
}
